import React from 'react';
import CircleChart from '../CircleChart';
import CO2eShowComponent from '../CO2eShowComponent';
import EthicsShow from '../EthicsShow';
import { getDishAverages } from '../../utils/sustainabilityAverages';

const DagensDishCard = ({
  item,
  onClick,
  onProductClick,
  className = '',
  darkMode = false,
  mealTypeTags = [],
}) => {
  const averages = getDishAverages(item);

  const renderCharts = () => (
    <div className="flex justify-center items-center w-full gap-4">
      <div className="text-center">
        <CircleChart value={averages.environment_average || 0} size={60} strokeWidth={8} label="Miljö" darkMode={darkMode} />
      </div>
      <div className="text-center">
        <CircleChart value={averages.health_average || 0} size={60} strokeWidth={8} label="Hälsa" darkMode={darkMode} />
      </div>
      <div className="text-center">
        <CircleChart value={averages.social_average || 0} size={60} strokeWidth={8} label="Rättvisa" darkMode={darkMode} />
      </div>
      {/* <div className="text-center">
        <CircleChart value={100} size={60} strokeWidth={8} label="Transparens" darkMode={darkMode} />
      </div> */}
    </div>
  );

  const renderInfo = () => (
    <div className="text-center mb-4">
      <h2 className={`text-2xl font-bold mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
        {item.name}
      </h2>
      
      {/* Ethics and weight on one line */}
      <div className={`flex items-center justify-center space-x-3 mb-3 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
        <EthicsShow
          isAnimal={item.is_animal}
          isAnimalKilled={item.is_animal_killed}
          isVegan={item.is_vegan}
          isVegetarian={item.is_vegetarian}
          ethicsUnknownConfirmed={item.ethics_unknown_confirmed}
          size="large"
          showLabels={true}
          className={darkMode ? 'text-white' : ''}
        />
        <span className="text-gray-400">•</span>
        <span className="font-medium">{item.size} {item.unit_abbr}</span>
      </div>

      {/* Meal type tags */}
      <div className="flex justify-center gap-2 mb-4">
        {Object.entries(mealTypeTags).map(([tag, isActive]) => (
          <span
            key={`meal-${tag}`}
            className={`inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-medium border ${
              isActive
                ? 'bg-green-100 text-green-800 border-green-200'
                : 'bg-gray-100 text-gray-500 border-gray-200'
            }`}
            title={
              tag === 'F' ? 'Frukost' : 
              tag === 'L' ? 'Lunch' : 
              tag === 'M' ? 'Middag' :
              tag === 'MM' ? 'Mellanmål' :
              tag === 'SM' ? 'Småmål' :
              tag === 'KM' ? 'Kvällsmål' :
              tag === 'D' ? 'Desser' :
              tag === 'Ö' ? 'Övrigt' : tag
            }
          >
            {tag}
          </span>
        ))}
      </div>
      
      {/* CTA buttons */}
      <div className="flex justify-center gap-3">
        <button
          type="button"
          onClick={onClick}
          className={`px-6 py-3 rounded-xl font-semibold text-white transition-all duration-200 hover:scale-105 cursor-pointer ${
            darkMode ? 'bg-orange-500 hover:bg-orange-600' : 'bg-orange-500 hover:bg-orange-600'
          }`}
        >
          QR Vy
        </button>
        <button
          type="button"
          onClick={onProductClick}
          className={`px-6 py-3 rounded-xl font-semibold transition-all duration-200 hover:scale-105 cursor-pointer ${
            darkMode
              ? 'bg-blue-500 hover:bg-blue-600 text-white'
              : 'bg-blue-500 hover:bg-blue-600 text-white'
          }`}
        >
          Produkt
        </button>
      </div>
    </div>
  );

  const renderImage = () => (
    <div className="w-full h-64 bg-gradient-to-br from-gray-100 to-gray-200 rounded-t-2xl flex items-center justify-center overflow-hidden mb-4">
      {item.image && item.image !== "" ? (
        <img
          src={item.image}
          alt={item.name}
          className="w-full h-full object-cover"
          onError={(e) => {
            e.target.style.display = 'none';
            if (e.target.nextSibling) {
              e.target.nextSibling.style.display = 'flex';
            }
          }}
          onLoad={(e) => {
            if (e.target.nextSibling) {
              e.target.nextSibling.style.display = 'none';
            }
          }}
        />
      ) : null}
      <img
        src="/assets/icons/svg/default-image-placeholder.svg"
        alt="Not Found"
        className={`w-32 h-32 text-gray-400 ${item.image && item.image !== "" ? 'hidden' : 'flex'} items-center justify-center`}
      />
    </div>
  );

  return (
    <div
      className={`${
        darkMode 
          ? 'bg-gray-800 border-gray-700' 
          : 'bg-white border-gray-200'
      } rounded-2xl shadow-none border overflow-hidden hover:shadow-lg transition-all duration-200 ${className}`}
    >
      {renderImage()}
      {renderInfo()}
      
      <div className="px-6 pb-6">
        <div className="border-t pt-6">
          <h3 className={`text-center text-sm font-semibold uppercase tracking-wider mb-4 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
            Hållbarhetsvärden
          </h3>
          {renderCharts()}
          <div className="mt-6 text-center">
            <CO2eShowComponent co2ePerKg={item.CO2e_menuwise} size={item.size} unit_id={item.unit_id} darkMode={darkMode} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DagensDishCard;
